module.exports = __webpack_public_path__ + "media/site/images/case_studies/ekanban/solution3_1@2x-08e9d048ef1818f16c0ce2af5a1bd913.png";